/* 
Object:         Import
Description:    Logic and events for the module Import
Used in:        Import
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";
import * as main        from "../main";
import * as navigation  from "../navigation";
import * as viewmode    from "../viewmode";

/**
 * Delete item from grid
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as ImportVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Import/Delete?importId=" + dataItem.ImportID),
            success: function (responseData) {
                // Refresh datasource grid 
                $("#ImportGrid").data("kendoGrid").dataSource.read();
            }
        });
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * Update a item from grid
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ImportVM;

    // Label
    const label = dataItem.Label;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Import/Edit?importId=" + dataItem.ImportID + "&breadcrumbLabel=" + label);
}

/**
 * Show item from grid
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem 
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ImportVM;

    // Label
    const label = dataItem.Label;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Import/Show?importId=" + dataItem.ImportID + "&breadcrumbLabel=" + label);
}

export function visibilityItem(dataItem: OverviewVM, nodeId: number): boolean {
    return dataItem.NodeID === nodeId;
}

/**
 * Show item from grid
 * @param {JQuery.Event & { currentTarget: HTMLElement }} e
 */
export function importFile(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem 
    var dataItem = this.dataItem($(e.currentTarget).closest("tr")) as ImportVM;

    // Label
    var label = dataItem.Label;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Import/ImportFile?importId=" + dataItem.ImportID + "&breadcrumbLabel=" + label);
}

export function uTCChanged(checked: boolean): void {
    main.setHideDivBootstrap("divSummertime", !checked);
    main.setHideDivBootstrap("divDSTID", !checked);
}

export function onStoreTableNameChanged(e: kendo.ui.DropDownListChangeEvent): void {
    const storeTableName = e.sender.value();
    $("#DivImportColumns").load(appsettings.getUrl("Import/GetNewImportColumns?storeTableName=" + storeTableName));
}

export function divImportColumnsRefresh(importId: number): void {
    $("#DivImportColumns").load(appsettings.getUrl("Import/GetImportColumns?importId=" + importId));
}

export function importColumnAddClicked(importId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Import/AddImportColumnItem") + "?importId=" + importId,
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == true) {
                    divImportColumnsRefresh(importId);

                    //main.openActionsDialog(' ', responseData.Message,
                    //    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }
        }
    });
}

export function importColumnDeleteClicked(importColumnId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Import/DeleteImportColumnItem") + "?importColumnId=" + importColumnId,
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == true) {
                    $("#IC_" + importColumnId + "_Row").remove();

                    //if (importColumnId > 0) {
                    //    main.openActionsDialog(' ', responseData.Message,
                    //        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    //}
                }
            }
        }
    });
}
